export const FormDataList = (arr) => {
  var formData = new FormData();
  arr.forEach((e) => {
    formData.append(e.key, e.value);
  });
  return formData;
};
